export const iconFontAwesomeTravelHotelHelicopter = (
	<i className="fa-solid fa-helicopter"></i>
);
